var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRm4Scc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "img",
    viewBox: "0 0 79.004204 93.189262",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Royal Mail Code") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-3.3261924,-3.8480038)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1195"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g121",
    transform: "translate(0.64794767)",
    style: {
      fill: "#007bff",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect2813",
    style: {
      fill: "#007bff",
      fillOpacity: 1,
      strokeWidth: 0.12783
    },
    d: "M 8.279475,3.8480046 V 17.851079 H 9.6797817 V 3.8480046 Z m 2.800615,0 V 17.851079 h 1.400308 V 3.8480046 Z m -8.4018453,5.60123 v 2.8006144 h 1.400307 V 9.4492346 Z m 2.800615,0 v 2.8006144 h 1.400307 V 9.4492346 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect2813-3",
    style: {
      fill: "#007bff",
      fillOpacity: 1,
      strokeWidth: 0.12783
    },
    d: "m 22.119884,3.8480039 v 8.4018451 h 1.400307 V 3.8480039 Z m 2.800615,0 V 17.85108 h 1.400308 V 3.8480039 Z m -8.401845,5.6012302 v 2.8006149 h 1.400307 V 9.4492341 Z m 2.800615,0 V 17.85108 h 1.400307 V 9.4492341 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect2813-4",
    style: {
      fill: "#007bff",
      fillOpacity: 1,
      strokeWidth: 0.12783
    },
    d: "M 35.960294,3.848004 V 17.85108 h 1.400307 V 3.848004 Z m 2.800615,0 v 8.401845 h 1.400308 V 3.848004 Z m -8.401845,5.6012302 v 2.8006148 h 1.400307 V 9.4492342 Z m 2.800615,0 V 17.85108 h 1.400307 V 9.4492342 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect2813-1",
    style: {
      fill: "#007bff",
      fillOpacity: 1,
      strokeWidth: 0.12783
    },
    d: "m 49.800703,3.848004 v 8.401845 h 1.400308 V 3.848004 Z m 2.800616,0 V 17.85108 h 1.400307 V 3.848004 Z m -8.401846,5.60123 v 8.401846 h 1.400308 V 9.449234 Z m 2.800615,0 v 2.800615 h 1.400308 V 9.449234 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect2813-2",
    style: {
      fill: "#007bff",
      fillOpacity: 1,
      strokeWidth: 0.0990163
    },
    d: "M 63.641116,3.8480038 V 17.85108 h 1.400308 V 3.8480038 Z m 2.800616,0 v 8.4018452 h 1.400307 V 3.8480038 Z M 58.039886,9.449234 v 8.401846 h 1.400308 V 9.449234 Z m 2.800615,0 v 2.800615 h 1.400308 V 9.449234 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect2813-9",
    style: {
      fill: "#007bff",
      fillOpacity: 1,
      strokeWidth: 0.0990163
    },
    d: "m 77.481528,3.848004 v 8.401846 h 1.400307 V 3.848004 Z m 2.800615,0 V 12.24985 H 81.68245 V 3.848004 Z M 71.880297,9.4492342 V 17.85108 h 1.400308 V 9.4492342 Z m 2.800615,0 V 17.85108 H 76.08122 V 9.4492342 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g169",
    transform: "translate(0.64794767,-0.99208859)",
    style: {
      fill: "#007bff",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect2813-31",
    style: {
      fill: "#007bff",
      fillOpacity: 1,
      strokeWidth: 0.12783
    },
    d: "m 5.4788596,24.636637 v 8.401846 h 1.400308 v -8.401846 z m 5.6012304,0 v 14.003076 h 1.400308 V 24.636637 Z m -8.4018453,5.60123 v 2.800616 h 1.4003075 v -2.800616 z m 5.6012299,0 v 8.401846 h 1.400308 v -8.401846 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect2813-90",
    style: {
      fill: "#007bff",
      fillOpacity: 1,
      strokeWidth: 0.12783
    },
    d: "m 19.319269,24.636637 v 14.003076 h 1.400307 V 24.636637 Z m 5.60123,0 v 14.003076 h 1.400308 V 24.636637 Z m -8.401845,5.60123 v 2.800616 h 1.400307 v -2.800616 z m 5.60123,0 v 2.800616 h 1.400307 v -2.800616 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect2813-34",
    style: {
      fill: "#007bff",
      fillOpacity: 1,
      strokeWidth: 0.0990163
    },
    d: "m 33.159679,24.636637 v 14.003075 h 1.400307 V 24.636637 Z m 5.60123,0 v 8.401845 h 1.400308 v -8.401845 z m -8.401845,5.60123 v 2.800615 h 1.400307 v -2.800615 z m 5.60123,0 v 8.401845 h 1.400307 v -8.401845 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect2813-0",
    style: {
      fill: "#007bff",
      fillOpacity: 1,
      strokeWidth: 0.12783
    },
    d: "m 47.000088,24.636637 v 8.401845 h 1.400308 v -8.401845 z m 5.601231,0 v 14.003076 h 1.400307 V 24.636637 Z m -8.401846,5.60123 v 8.401846 h 1.400308 v -8.401846 z m 5.601231,0 v 2.800615 h 1.400307 v -2.800615 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect2813-6",
    style: {
      fill: "#007bff",
      fillOpacity: 1,
      strokeWidth: 0.0990163
    },
    d: "m 60.840502,24.636637 v 8.401846 h 1.400307 v -8.401846 z m 5.60123,0 v 8.401846 h 1.400307 v -8.401846 z m -8.401846,5.60123 v 8.401846 h 1.400308 v -8.401846 z m 5.601231,0 v 8.401846 h 1.400307 v -8.401846 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect2813-8",
    style: {
      fill: "#007bff",
      fillOpacity: 1,
      strokeWidth: 0.0990163
    },
    d: "M 74.680912,24.636637 V 38.639713 H 76.08122 V 24.636637 Z m 5.601231,0 v 8.401846 h 1.400307 v -8.401846 z m -8.401846,5.601231 v 8.401845 h 1.400308 v -8.401845 z m 5.60123,0 v 2.800615 h 1.400308 v -2.800615 z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g225",
    transform: "translate(0.64794767,-5.042479)",
    style: {
      fill: "#007bff",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect2813-24",
    style: {
      fill: "#007bff",
      fillOpacity: 1,
      strokeWidth: 0.0990163
    },
    d: "m 5.4788597,48.483572 v 8.401845 h 1.400308 v -8.401845 z m 2.800615,0 v 14.003076 h 1.400308 V 48.483572 Z m -5.60123,5.60123 v 2.800615 h 1.400308 v -2.800615 z m 8.4018453,0 v 8.401846 h 1.400308 v -8.401846 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect2813-32",
    style: {
      fill: "#007bff",
      fillOpacity: 1,
      strokeWidth: 0.0990163
    },
    d: "m 19.319269,48.483572 v 14.003076 h 1.400308 V 48.483572 Z m 2.800615,0 v 8.401845 h 1.400308 v -8.401845 z m -5.60123,5.60123 v 2.800615 h 1.400308 v -2.800615 z m 8.401845,0 v 8.401846 h 1.400308 v -8.401846 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect2813-247",
    style: {
      fill: "#007bff",
      fillOpacity: 1,
      strokeWidth: 0.057167
    },
    d: "m 33.159679,48.483572 v 14.003076 h 1.400307 V 48.483572 Z m 2.800615,0 v 14.003076 h 1.400307 V 48.483572 Z m -5.60123,5.60123 v 2.800615 h 1.400307 v -2.800615 z m 8.401845,0 v 2.800615 h 1.400308 v -2.800615 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect2813-10",
    style: {
      fill: "#007bff",
      fillOpacity: 1,
      strokeWidth: 0.0990158
    },
    d: "m 47.000088,48.483572 v 8.401846 h 1.400307 v -8.401846 z m 2.800615,0 v 8.401846 h 1.400307 v -8.401846 z m -5.60123,5.60123 v 8.401846 h 1.400307 v -8.401846 z m 8.401845,0 v 8.401846 h 1.400308 v -8.401846 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect2813-322",
    style: {
      fill: "#007bff",
      fillOpacity: 1,
      strokeWidth: 0.057167
    },
    d: "m 60.840501,48.483572 v 8.401845 h 1.400307 v -8.401845 z m 2.800615,0 v 14.003077 h 1.400307 V 48.483572 Z m -5.60123,5.60123 v 8.401847 h 1.400307 v -8.401847 z m 8.401845,0 v 2.800615 h 1.400308 v -2.800615 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect2813-08",
    style: {
      fill: "#007bff",
      fillOpacity: 1,
      strokeWidth: 0.057167
    },
    d: "M 74.680912,48.483572 V 62.486647 H 76.08122 V 48.483572 Z m 2.800615,0 v 8.401845 h 1.400308 v -8.401845 z m -5.60123,5.60123 v 8.401845 h 1.400308 v -8.401845 z m 8.401845,0 v 2.800615 h 1.400308 v -2.800615 z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g281",
    transform: "translate(0.64794767,-7.8902999)",
    style: {
      fill: "#007bff",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect2813-36",
    style: {
      fill: "#007bff",
      fillOpacity: 1,
      strokeWidth: 0.057167
    },
    d: "m 2.6782447,71.127937 v 8.401842 h 1.400307 v -8.401842 z m 8.4018453,0 v 14.003072 h 1.400308 V 71.127937 Z m -5.6012303,5.60123 v 2.800612 h 1.400307 v -2.800612 z m 2.800615,0 v 8.401842 h 1.400307 v -8.401842 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect2813-28",
    style: {
      fill: "#007bff",
      fillOpacity: 1,
      strokeWidth: 0.057167
    },
    d: "m 16.518654,71.127937 v 8.401842 h 1.400307 v -8.401842 z m 8.401845,0 v 14.003072 h 1.400308 V 71.127937 Z m -5.60123,5.60123 v 8.401842 h 1.400307 v -8.401842 z m 2.800615,0 v 2.800612 h 1.400308 v -2.800612 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect2813-93",
    style: {
      fill: "#007bff",
      fillOpacity: 1,
      strokeWidth: 0.0990158
    },
    d: "m 30.359064,71.127937 v 8.401842 h 1.400308 v -8.401842 z m 8.401846,0 v 8.401842 h 1.400307 v -8.401842 z m -5.60123,5.60123 v 8.401842 h 1.400307 v -8.401842 z m 2.800615,0 v 8.401842 h 1.400307 v -8.401842 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect2813-14",
    style: {
      fill: "#007bff",
      fillOpacity: 1,
      strokeWidth: 0.057167
    },
    d: "m 44.199473,71.127937 v 14.003072 h 1.400308 V 71.127937 Z m 8.401845,0 v 14.003072 h 1.400309 V 71.127937 Z m -5.60123,5.601231 v 2.800611 h 1.400308 v -2.800611 z m 2.800615,0 v 2.800611 h 1.400308 v -2.800611 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect2813-04",
    style: {
      fill: "#007bff",
      fillOpacity: 1,
      strokeWidth: 0.0990158
    },
    d: "m 58.039886,71.127937 v 14.003072 h 1.400308 V 71.127937 Z m 8.401846,0 v 8.401842 h 1.400307 v -8.401842 z m -5.601231,5.60123 v 2.800612 h 1.400308 v -2.800612 z m 2.800615,0 v 8.401842 h 1.400308 v -8.401842 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect2813-06",
    style: {
      fill: "#007bff",
      fillOpacity: 1,
      strokeWidth: 0.0990158
    },
    d: "m 71.880297,71.127937 v 14.003072 h 1.400308 V 71.127937 Z m 8.401845,0 v 8.401842 h 1.400308 v -8.401842 z m -5.60123,5.60123 v 8.401842 h 1.400308 v -8.401842 z m 2.800615,0 v 2.800612 h 1.400308 v -2.800612 z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g289",
    transform: "translate(0.64794767,-13.074383)",
    style: {
      fill: "#007bff",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect2813-909",
    style: {
      fill: "#007bff",
      fillOpacity: 1,
      strokeWidth: 0.0990158
    },
    d: "m 2.6782447,96.108567 v 8.401853 h 1.400308 v -8.401853 z m 5.601231,0 v 14.003083 h 1.400307 V 96.108567 Z m -2.800616,5.601233 v 2.80062 h 1.400308 v -2.80062 z m 5.6012313,0 v 8.40185 h 1.400307 v -8.40185 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect2813-29",
    style: {
      fill: "#007bff",
      fillOpacity: 1,
      strokeWidth: 0.0990158
    },
    d: "m 16.518654,96.108567 v 8.401843 h 1.400307 v -8.401843 z m 5.60123,0 v 8.401843 h 1.400308 v -8.401843 z m -2.800615,5.601233 v 8.40184 h 1.400308 v -8.40184 z m 5.60123,0 v 8.40184 h 1.400308 v -8.40184 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect2813-03",
    style: {
      fill: "#007bff",
      fillOpacity: 1,
      strokeWidth: 0.057167
    },
    d: "m 30.359064,96.108567 v 8.401843 h 1.400307 v -8.401843 z m 5.60123,0 v 14.003073 h 1.400308 V 96.108567 Z m -2.800615,5.601233 v 8.40184 h 1.400307 v -8.40184 z m 5.60123,0 v 2.80061 h 1.400308 v -2.80061 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect2813-243",
    style: {
      fill: "#007bff",
      fillOpacity: 1,
      strokeWidth: 0.057167
    },
    d: "M 44.199473,96.108567 V 110.11165 H 45.59978 V 96.108567 Z m 5.60123,0 v 8.401853 h 1.400308 v -8.401853 z m -2.800615,5.601233 v 2.80062 h 1.400308 v -2.80062 z m 5.60123,0 v 8.40185 h 1.400308 v -8.40185 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect2813-30",
    style: {
      fill: "#007bff",
      fillOpacity: 1,
      strokeWidth: 0.057167
    },
    d: "m 58.039886,96.108567 v 14.003073 h 1.400308 V 96.108567 Z m 5.601231,0 v 14.003073 h 1.400307 V 96.108567 Z m -2.800616,5.601233 v 2.80061 h 1.400308 v -2.80061 z m 5.601231,0 v 2.80061 h 1.400307 v -2.80061 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect2813-64",
    style: {
      fill: "#007bff",
      fillOpacity: 1,
      strokeWidth: 0.0990158
    },
    d: "m 71.880297,96.108567 v 14.003083 h 1.400307 V 96.108567 Z m 5.60123,0 v 8.401853 h 1.400308 v -8.401853 z m -2.800615,5.601233 v 8.40185 h 1.400307 v -8.40185 z m 5.60123,0 v 2.80062 h 1.400308 v -2.80062 z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRm4Scc);
export default __webpack_public_path__ + "static/media/rm4scc.5a04af9627c63935389fe78ebe94ea21.svg";
export { ForwardRef as ReactComponent };